import { CONSTANTS } from '../constants';

/**
 * Stone/projectile game logic.
 * Pure data — no Phaser dependencies.
 */
export interface IStoneState {
  x: number;
  y: number;
  vx: number;
  vy: number;
  rotation: number;
  life: number;
  active: boolean;
}

export function createStone(x: number, y: number, facing: 'left' | 'right'): IStoneState {
  const vx = facing === 'right' ? CONSTANTS.STONE_VX : -CONSTANTS.STONE_VX;
  return {
    x, y,
    vx,
    vy: CONSTANTS.STONE_VY,
    rotation: 0,
    life: CONSTANTS.STONE_LIFETIME,
    active: true,
  };
}

export function updateStone(stone: IStoneState, deltaTime: number): void {
  const dt = deltaTime / 16.67;
  stone.vy += CONSTANTS.STONE_GRAVITY * dt;
  stone.x += stone.vx * dt;
  stone.y += stone.vy * dt;
  stone.rotation += stone.vx * 0.1 * dt;
  stone.life -= dt;
  if (stone.life <= 0) {
    stone.active = false;
  }
}

export function stoneOverlap(
  stone: IStoneState,
  enemyHitbox: { x: number; y: number; width: number; height: number }
): boolean {
  const stoneHalfW = CONSTANTS.STONE_SIZE_X / 2;
  const stoneHalfH = CONSTANTS.STONE_SIZE_Y / 2;
  const stoneLeft = stone.x - stoneHalfW;
  const stoneRight = stone.x + stoneHalfW;
  const stoneTop = stone.y - stoneHalfH;
  const stoneBottom = stone.y + stoneHalfH;
  return (
    stoneRight > enemyHitbox.x &&
    stoneLeft < enemyHitbox.x + enemyHitbox.width &&
    stoneBottom > enemyHitbox.y &&
    stoneTop < enemyHitbox.y + enemyHitbox.height
  );
}
